import CarouselWrapper from "./carousel";
import ComparisonComponent from "./Benifits/comparision";
import WorkProcessComponent from "./HowWeWorks";
import BenifitsWrapper from "./Benifits";
import MajorServices from "./feature_services";
import TestimonialSlider from "./Testimonials";
import Ratings from "./socialMediaRatings";
import Marquee from "./Morquee";
import SeoInfo from "../../SeoInfo";

const Home = () => {
  return (
    <>
      <SeoInfo
        title="No.1 Online Car Service – Car Repairs Simplified | Go Clutch"
        description="Go Clutch offers expert online car service at your doorstep. Easy booking, professional mechanics & Car repairs—keeping your car in peak condition!"
      />
      <CarouselWrapper />
      <ComparisonComponent />
      <MajorServices />
      <WorkProcessComponent />
      <BenifitsWrapper />
      <TestimonialSlider />
      <Marquee />
      <Ratings />
    </>
  );
};

export default Home;
